import { render, staticRenderFns } from "./MessageDropdown.vue?vue&type=template&id=876f26d4&"
import script from "./MessageDropdown.vue?vue&type=script&lang=js&"
export * from "./MessageDropdown.vue?vue&type=script&lang=js&"
import style0 from "./MessageDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MessageDropdown.vue"
export default component.exports